import { useState } from "react";
import { Mail, Link2, Share2, Check } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

/* Brand SVG icons — kept as small inline components for a zero-dependency, crisp render. */
const IcWhatsApp = (p) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...p}><path d="M20.52 3.48A11.9 11.9 0 0 0 12 0C5.4 0 0 5.4 0 12c0 2.11.55 4.16 1.6 5.98L0 24l6.19-1.63A11.94 11.94 0 0 0 12 24c6.6 0 12-5.4 12-12 0-3.19-1.24-6.19-3.48-8.52ZM12 21.82a9.85 9.85 0 0 1-5.01-1.37l-.36-.21-3.67.97.98-3.58-.24-.37A9.83 9.83 0 0 1 2.18 12C2.18 6.6 6.6 2.18 12 2.18c2.63 0 5.1 1.03 6.96 2.9A9.75 9.75 0 0 1 21.82 12c0 5.4-4.42 9.82-9.82 9.82Zm5.4-7.36c-.3-.15-1.77-.87-2.04-.97-.27-.1-.47-.15-.67.15s-.77.97-.94 1.17c-.17.2-.35.23-.65.08-.3-.15-1.27-.47-2.42-1.49a9.13 9.13 0 0 1-1.68-2.09c-.18-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.18.2-.3.3-.5.1-.2.05-.38-.03-.53-.08-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.53.08-.8.38s-1.06 1.03-1.06 2.5c0 1.47 1.08 2.9 1.23 3.1.15.2 2.13 3.25 5.16 4.56.72.31 1.28.5 1.72.63.72.23 1.38.2 1.9.12.58-.09 1.77-.72 2.02-1.42.25-.7.25-1.3.17-1.42-.07-.13-.27-.2-.57-.35Z"/></svg>
);
const IcFacebook = (p) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...p}><path d="M22 12a10 10 0 1 0-11.56 9.88v-6.99H7.9V12h2.54V9.8c0-2.5 1.5-3.89 3.77-3.89 1.1 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56V12h2.77l-.44 2.89h-2.33v6.99A10 10 0 0 0 22 12Z"/></svg>
);
const IcInstagram = (p) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...p}><path d="M12 2.16c3.2 0 3.58.01 4.85.07 1.17.05 1.8.25 2.22.41.56.22.96.48 1.38.9.42.42.68.82.9 1.38.17.42.36 1.05.41 2.22.06 1.27.07 1.65.07 4.85s-.01 3.58-.07 4.85c-.05 1.17-.25 1.8-.41 2.22-.22.56-.48.96-.9 1.38-.42.42-.82.68-1.38.9-.42.17-1.05.36-2.22.41-1.27.06-1.65.07-4.85.07s-3.58-.01-4.85-.07c-1.17-.05-1.8-.25-2.22-.41a3.72 3.72 0 0 1-1.38-.9 3.72 3.72 0 0 1-.9-1.38c-.17-.42-.36-1.05-.41-2.22C2.17 15.58 2.16 15.2 2.16 12s.01-3.58.07-4.85c.05-1.17.25-1.8.41-2.22.22-.56.48-.96.9-1.38.42-.42.82-.68 1.38-.9.42-.17 1.05-.36 2.22-.41C8.42 2.17 8.8 2.16 12 2.16ZM12 0C8.74 0 8.33.01 7.05.07 5.78.13 4.9.33 4.14.63a5.9 5.9 0 0 0-2.13 1.38A5.9 5.9 0 0 0 .63 4.14C.33 4.9.13 5.78.07 7.05.01 8.33 0 8.74 0 12s.01 3.67.07 4.95c.06 1.27.26 2.15.56 2.91.31.79.72 1.46 1.38 2.13a5.9 5.9 0 0 0 2.13 1.38c.76.3 1.64.5 2.91.56C8.33 23.99 8.74 24 12 24s3.67-.01 4.95-.07c1.27-.06 2.15-.26 2.91-.56a5.9 5.9 0 0 0 2.13-1.38 5.9 5.9 0 0 0 1.38-2.13c.3-.76.5-1.64.56-2.91.06-1.28.07-1.69.07-4.95s-.01-3.67-.07-4.95c-.06-1.27-.26-2.15-.56-2.91a5.9 5.9 0 0 0-1.38-2.13A5.9 5.9 0 0 0 19.86.63c-.76-.3-1.64-.5-2.91-.56C15.67.01 15.26 0 12 0Zm0 5.84a6.16 6.16 0 1 0 0 12.32 6.16 6.16 0 0 0 0-12.32ZM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8Zm6.4-11.85a1.44 1.44 0 1 0 0 2.88 1.44 1.44 0 0 0 0-2.88Z"/></svg>
);
const IcTikTok = (p) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...p}><path d="M19.32 6.11a5.44 5.44 0 0 1-3.28-1.1 5.5 5.5 0 0 1-2.05-3.44V1.5h-3.4v13.24a3.14 3.14 0 1 1-2.15-2.98V8.31a6.54 6.54 0 1 0 5.55 6.46V8.94a8.87 8.87 0 0 0 5.33 1.75V7.3c-.02 0-.02-1.19 0-1.19Z"/></svg>
);
const IcLinkedIn = (p) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...p}><path d="M20.45 20.45h-3.55v-5.57c0-1.33-.02-3.04-1.85-3.04-1.86 0-2.14 1.45-2.14 2.95v5.66H9.35V9h3.41v1.56h.05c.47-.9 1.63-1.85 3.37-1.85 3.6 0 4.27 2.37 4.27 5.45v6.29ZM5.34 7.43a2.06 2.06 0 1 1 0-4.12 2.06 2.06 0 0 1 0 4.12ZM7.12 20.45H3.56V9h3.56v11.45ZM22.22 0H1.77C.79 0 0 .77 0 1.72v20.56C0 23.23.79 24 1.77 24h20.45C23.2 24 24 23.23 24 22.28V1.72C24 .77 23.2 0 22.22 0Z"/></svg>
);
const IcX = (p) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...p}><path d="M18.244 2H21.5l-7.5 8.577L23 22h-6.828l-4.79-6.264L5.9 22H2.64l8.04-9.19L1 2h6.914l4.32 5.71L18.244 2Zm-1.196 18h1.833L7.03 4H5.09l11.958 16Z"/></svg>
);
const IcTelegram = (p) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...p}><path d="M22.05 1.58 1.05 9.94c-.76.3-.76.85-.14 1.04l5.36 1.67 2.08 6.36c.24.63.44.9.87.9.34 0 .5-.15.7-.35l2.55-2.49 5.3 3.92c.97.55 1.66.27 1.9-.9L23.13 3.1c.35-1.53-.28-2.14-1.08-1.52Zm-4.87 5.44L8.16 15.7l-.35 3.7-2.16-6.61 12.5-7.9c.56-.35 1.08-.15.56.2Z"/></svg>
);
const IcMessenger = (p) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...p}><path d="M12 0C5.28 0 0 4.92 0 11.4c0 3.4 1.44 6.36 3.8 8.4v4.2l3.48-1.92c.94.26 1.94.4 3 .4h.24l-.16-.04C16.72 22.44 24 17.44 24 11.4 24 4.92 18.72 0 12 0Zm1.28 15.36L10.16 12l-6.08 3.36 6.68-7.08 3.28 3.36 5.92-3.36-6.68 7.08Z"/></svg>
);

const btnClass = "group flex flex-col items-center justify-center gap-2 min-w-[68px] p-3 border border-gray-200 hover:border-[#0A1128] hover:-translate-y-0.5 hover:shadow-md transition bg-white";
const iconClass = "w-5 h-5";
const labelClass = "text-[10px] tracking-widest uppercase text-gray-500 group-hover:text-[#0A1128]";

export default function ShareBar({ title, url, description = "", image = "", slug = "", initialShareCount = 0, onShare }) {
  const [copied, setCopied] = useState(false);
  const [count, setCount] = useState(initialShareCount || 0);
  const shareUrl = url || (typeof window !== "undefined" ? window.location.href : "");
  const shareTitle = title || document.title;
  const shareText = description || "";

  const ping = (platform) => {
    if (!slug) return;
    api.post(`/blog/${slug}/share`, { platform })
      .then((r) => {
        const c = r?.data?.share_count;
        if (typeof c === "number") setCount(c);
        onShare?.(platform, c);
      })
      .catch(() => { /* silent — never block the share */ });
  };

  const enc = encodeURIComponent;
  const links = {
    whatsapp: `https://api.whatsapp.com/send?text=${enc(shareTitle + " — " + shareUrl)}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${enc(shareUrl)}&quote=${enc(shareTitle)}`,
    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${enc(shareUrl)}`,
    x:        `https://twitter.com/intent/tweet?text=${enc(shareTitle)}&url=${enc(shareUrl)}`,
    telegram: `https://t.me/share/url?url=${enc(shareUrl)}&text=${enc(shareTitle)}`,
    messenger:`fb-messenger://share?link=${enc(shareUrl)}`,
    email:    `mailto:?subject=${enc(shareTitle)}&body=${enc((shareText ? shareText + "\n\n" : "") + shareUrl)}`,
  };

  const openPopup = (href, platform) => {
    const w = 640, h = 640;
    const left = (window.screen.width - w) / 2;
    const top = (window.screen.height - h) / 2;
    window.open(href, "_blank", `width=${w},height=${h},left=${left},top=${top},noopener,noreferrer`);
    if (platform) ping(platform);
  };

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      toast.success("Link copied to clipboard");
      setTimeout(() => setCopied(false), 2000);
      ping("copy");
    } catch {
      toast.error("Could not copy link");
    }
  };

  /* Instagram + TikTok have no public web share URL — use native share sheet on mobile or copy link + guidance toast. */
  const shareToApp = async (appName, platform) => {
    if (navigator.share) {
      try {
        await navigator.share({ title: shareTitle, text: shareText, url: shareUrl });
        ping(platform);
        return;
      } catch {
        /* user cancelled or unsupported — fall through */
      }
    }
    try {
      await navigator.clipboard.writeText(shareUrl);
      toast.success(`Link copied — paste it into your ${appName} post or story`);
      ping(platform);
    } catch {
      toast.error(`Copy failed. Manually copy: ${shareUrl}`);
    }
  };

  const shareToMessenger = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title: shareTitle, text: shareText, url: shareUrl });
        ping("messenger");
        return;
      } catch { /* fall through */ }
    }
    /* Try Messenger deep link (mobile). If blocked/unsupported, copy link. */
    const start = Date.now();
    const w = window.open(links.messenger, "_blank");
    ping("messenger");
    setTimeout(async () => {
      if (Date.now() - start < 1500 && (!w || w.closed || typeof w.closed === "undefined")) {
        try {
          await navigator.clipboard.writeText(shareUrl);
          toast.success("Link copied — paste into Messenger");
        } catch { /* noop */ }
      }
    }, 800);
  };

  return (
    <div className="border-t border-b border-gray-200 py-8 my-12" data-testid="share-bar">
      <div className="flex items-center justify-between flex-wrap gap-4 mb-5">
        <div className="flex items-center gap-3">
          <Share2 className="w-4 h-4 text-[#688A4E]"/>
          <div className="overline">Share this article</div>
          {count > 0 && (
            <span className="ml-2 inline-flex items-center gap-1 text-[11px] tracking-widest uppercase bg-[#688A4E] text-white px-2 py-0.5" data-testid="share-count-badge">
              {count} share{count === 1 ? "" : "s"}
            </span>
          )}
        </div>
        <div className="text-xs text-gray-400 hidden sm:block truncate max-w-md">{shareTitle}</div>
      </div>

      <div className="flex flex-wrap gap-2">
        <button onClick={() => openPopup(links.whatsapp, "whatsapp")} className={btnClass} data-testid="share-whatsapp" aria-label="Share on WhatsApp" title="WhatsApp">
          <IcWhatsApp className={iconClass} style={{ color: "#25D366" }}/>
          <span className={labelClass}>WhatsApp</span>
        </button>
        <button onClick={() => openPopup(links.facebook, "facebook")} className={btnClass} data-testid="share-facebook" aria-label="Share on Facebook" title="Facebook">
          <IcFacebook className={iconClass} style={{ color: "#1877F2" }}/>
          <span className={labelClass}>Facebook</span>
        </button>
        <button onClick={() => shareToApp("Instagram", "instagram")} className={btnClass} data-testid="share-instagram" aria-label="Share to Instagram" title="Instagram">
          <IcInstagram className={iconClass} style={{ color: "#E4405F" }}/>
          <span className={labelClass}>Instagram</span>
        </button>
        <button onClick={() => shareToApp("TikTok", "tiktok")} className={btnClass} data-testid="share-tiktok" aria-label="Share to TikTok" title="TikTok">
          <IcTikTok className={iconClass} style={{ color: "#0A1128" }}/>
          <span className={labelClass}>TikTok</span>
        </button>
        <button onClick={() => openPopup(links.linkedin, "linkedin")} className={btnClass} data-testid="share-linkedin" aria-label="Share on LinkedIn" title="LinkedIn">
          <IcLinkedIn className={iconClass} style={{ color: "#0A66C2" }}/>
          <span className={labelClass}>LinkedIn</span>
        </button>
        <button onClick={() => openPopup(links.x, "x")} className={btnClass} data-testid="share-x" aria-label="Share on X" title="X (Twitter)">
          <IcX className={iconClass} style={{ color: "#0A1128" }}/>
          <span className={labelClass}>X</span>
        </button>
        <button onClick={() => openPopup(links.telegram, "telegram")} className={btnClass} data-testid="share-telegram" aria-label="Share on Telegram" title="Telegram">
          <IcTelegram className={iconClass} style={{ color: "#26A5E4" }}/>
          <span className={labelClass}>Telegram</span>
        </button>
        <button onClick={shareToMessenger} className={btnClass} data-testid="share-messenger" aria-label="Share on Messenger" title="Messenger">
          <IcMessenger className={iconClass} style={{ color: "#0084FF" }}/>
          <span className={labelClass}>Messenger</span>
        </button>
        <a href={links.email} onClick={() => ping("email")} className={btnClass} data-testid="share-email" aria-label="Share by email" title="Email">
          <Mail className={iconClass} style={{ color: "#688A4E" }}/>
          <span className={labelClass}>Email</span>
        </a>
        <button onClick={copyLink} className={btnClass} data-testid="share-copy" aria-label="Copy link" title="Copy link">
          {copied ? <Check className={iconClass} style={{ color: "#688A4E" }}/> : <Link2 className={iconClass} style={{ color: "#0A1128" }}/>}
          <span className={labelClass}>{copied ? "Copied" : "Copy Link"}</span>
        </button>
      </div>
    </div>
  );
}
